import { environment } from "@environments/environment";

const assetScriptUrl = environment.ASSETS_ENDPOINT + '/assets/scripts/';
const referenceDataUrl = environment.API_ENDPOINT + '/v1/referenceData/';

const endpoints = {
  getCountryEndpoint: referenceDataUrl + 'countries',
  getInstitutionEndpoint: environment.API_ENDPOINT + '/v1/institutions',
  getUserDetail: environment.API_ENDPOINT + '/v1/user',
  userChangeNotesEndpoint: environment.API_ENDPOINT + '/v1/userChangeNotes',
  campusDataEndpoint: environment.API_ENDPOINT + '/v1/institutions/',
  campusCourseTypeEndpoint: referenceDataUrl + 'campus',
  departmentTypeEndpoint: referenceDataUrl + 'department',
  intakeReferenceEndpoint: referenceDataUrl + 'intake',
  courseReferenceEndpoint: referenceDataUrl + 'course',
  instanceReferenceEndpoint: referenceDataUrl + 'courseInstance',
  availabilityReferenceEndpoint: referenceDataUrl + 'availabilitiy',
  feeReferenceEndpoint: referenceDataUrl + 'Fees',
  relatedCourseReferenceEndpoint: referenceDataUrl + 'relatedCourseInstances',
  courseGroupTypeReferenceEndpoint: referenceDataUrl + 'courseGroups',
  stagesReferenceEndpoint: referenceDataUrl + 'stages',
  modulesReferenceEndpoint: referenceDataUrl + 'modules',
  erReferenceEndpoint: referenceDataUrl + 'detailedentryrequirement',
  relatedInstitutionRefEndpoint: referenceDataUrl + 'relatedinstitutions',
  institutionReferenceEndpoint: referenceDataUrl + 'institutions',
  nonEduOrgReferenceEndpoint: referenceDataUrl + 'nonEducationalOrganisations',

  subjectReportUploadEndpoint: environment.API_ENDPOINT + '/v1/subjectclassificationReport/upload',
  subjectReportDownloadEndpoint: environment.API_ENDPOINT + '/v1/subjectclassificationReport/download',
  subjectReportListEndpoint: environment.API_ENDPOINT + '/v1/subjectclassificationReport/list',
  easyLoadInitDownloadEndpoint: environment.API_ENDPOINT + '/v1/easyLoad/initiateDownload',
  easyLoadReportDownloadEndpoint: environment.API_ENDPOINT + '/v1/easyLoad/download',
  easyLoadReportListEndpoint: environment.API_ENDPOINT + '/v1/easyLoad/list',
  easyLoadUploadEndpoint: environment.API_ENDPOINT + '/v1/easyLoad/upload',
  easyLoadReportFilterData: environment.API_ENDPOINT + '/v1/easyLoad',
  manageReportListEndpoint: environment.API_ENDPOINT + '/v1/reports',
  quickSearchEndpoint: environment.API_ENDPOINT + '/v1/quicksearch',
  nonEduOrgEndpoint: environment.API_ENDPOINT + '/v1/nonEducationalOrganisations',
  forwardGenerationEndpoint: environment.API_ENDPOINT + '/v1/forwardGeneration',

  campusFieldJson: assetScriptUrl + 'campus-fields.json',
  departmentFieldJson: assetScriptUrl + 'department-fields.json',
  intakeFieldJson: assetScriptUrl + 'intake-fields.json',
  courseFieldJson: assetScriptUrl + 'course-fields.json',
  courseInstanceFieldJson: assetScriptUrl + 'course-instance-fields.json',
  courseAvailabilityFieldJson: assetScriptUrl + 'course-availability-fields.json',
  feeFieldJson: assetScriptUrl + 'fee-fields.json',
  annualFeeConstants: assetScriptUrl + 'fee-annual-factor.json',
  generalCourseInstanceFieldJson: assetScriptUrl + 'general-course-instance-fields.json',
  generalCourseFieldJson: assetScriptUrl + 'general-course-fields.json',
  relatedCourseFieldJson: assetScriptUrl + 'pathway-course-fields.json',
  courseGroupTypeFieldJson: assetScriptUrl + 'course-group-type-fields.json',
  stagesFieldJson: assetScriptUrl + 'stages-fields.json',
  moduleFieldJson: assetScriptUrl + 'module-fields.json',
  erTestFieldJson: assetScriptUrl + 'er-test-fields.json',
  erQualFieldJson: assetScriptUrl + 'er-qualification-fields.json',
  relatedInstitutionFieldJson: assetScriptUrl + 'related-institution-fields.json',
  institutionFieldJson: assetScriptUrl + 'institution-fields.json',
  countryListJson: assetScriptUrl + 'country-list.json',
  subjectReportTemplate: assetScriptUrl + 'template/subject_report_template.xlsx',
  nonEduOrgFieldJson: assetScriptUrl + 'non-edu-org-fields.json',
  forwardGenerationFieldJson: assetScriptUrl + 'forward-generation-fields.json',

  gitlabFeatureFlagDetails: 'https://gitlab.com/api/v4/projects'
};

export const apiEndpointURL = endpoints;
